"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _appendCss = _interopRequireDefault(require("../utils/appendCss"));
var _classnames = _interopRequireDefault(require("classnames"));
var _useTextFromRef = _interopRequireWildcard(require("../utils/useTextFromRef"));
var _Icon_css = _interopRequireDefault(require("./Icon_css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/* complete list of icons can be found at:  https://material.io/tools/icons/?style=baseline */

const IconComp = _ref => {
  let {
    innerRef,
    icon,
    type,
    className,
    onClick,
    mdTheme,
    size,
    title,
    ...rest
  } = _ref;
  (0, _appendCss.default)("arc_icons", _Icon_css.default);
  const {
    ref,
    text
  } = (0, _useTextFromRef.default)();
  const isIcon = type === "icon";
  const renderIcon = () => {
    const iconClass = (0, _classnames.default)({
      "icon__elem": true,
      "material-icons": mdTheme === "filled",
      "material-icons-outlined": mdTheme === "outlined",
      "material-icons-round": mdTheme === "rounded",
      "material-icons-two-tone": mdTheme === "two-tone",
      "material-icons-sharp": mdTheme === "sharp",
      [`icon__${size}`]: true,
      [className]: isIcon
    });
    return /*#__PURE__*/_react.default.createElement("i", (0, _extends2.default)({
      role: "presentation",
      className: iconClass
    }, isIcon ? {
      onClick: onClick,
      alt: text,
      ...rest
    } : {
      alt: `${icon} icon`
    }), /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true"
    }, icon), /*#__PURE__*/_react.default.createElement(_useTextFromRef.HiddenRefElement, {
      ref: ref
    }, title));
  };
  if (!isIcon) {
    return /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
      ref: innerRef,
      type: "button",
      className: `icon__btn_elem  ${className}`,
      onClick: onClick,
      role: type,
      "aria-label": text
    }, rest), renderIcon());
  }
  return renderIcon();
};
const Icon = /*#__PURE__*/_react.default.forwardRef((_ref2, ref) => {
  let {
    type = "icon",
    className = "",
    mdTheme = "filled",
    size = "base",
    title = "",
    ...rest
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(IconComp, (0, _extends2.default)({
    innerRef: ref,
    type,
    className,
    mdTheme,
    size,
    title
  }, rest));
});
Icon.propTypes = {
  /** Icon ligature attribute */
  "icon": _propTypes.default.string.isRequired,
  /** Element type for the icon ["icon", "button", "link"] */
  "type": _propTypes.default.oneOf(["icon", "button", "link"]),
  /** The related material design theme signature [filled, outlined, rounded, two-tone, sharp] */
  "mdTheme": _propTypes.default.oneOf(["filled", "outlined", "rounded", "two-tone", "sharp"]),
  /** The size of the icon. [xxs, xs, sm, md, base, lg, xl, xxl, xxxl] */
  "size": _propTypes.default.oneOf(["xxs", "xs", "sm", "md", "base", "lg", "xl", "xxl", "xxxl"]),
  /** Custom class to pass on to the root icon element. */
  "className": _propTypes.default.string,
  /** onClick event handler.  Should be present when using type of "button" or "link". */
  "onClick": _propTypes.default.func,
  /** Alt tag for the icon. Will be placed on the button element when using "button" or "link" type, and should describe the action to be performed as well as the icon. If "icon" type, should be descriptive of the icon.. but can be ommitted if purely decorative in nature. */
  "title": _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  /**  NOTE: prop name is "ref". a React REF object reference that is only applied to the button element when using "button" or "link" type. */
  "React REF (ref)": _propTypes.default.object
};
var _default = exports.default = Icon;